function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M493.741,60.666L333.074,32.251c-1.135-0.202-2.348-0.201-3.482,0L170.667,60.358L11.742,32.251 c-2.912-0.515-5.902,0.285-8.167,2.185C1.31,36.336,0,39.141,0,42.098v389.389c0,4.851,3.481,9.002,8.258,9.847l160.667,28.415 c1.141,0.204,2.341,0.204,3.483,0l158.925-28.107l158.926,28.107c0.579,0.103,1.162,0.153,1.741,0.153 c2.331,0,4.611-0.816,6.426-2.338c2.266-1.9,3.574-4.705,3.574-7.662V70.513C502,65.662,498.519,61.511,493.741,60.666z  M160.667,447.979L20,423.1V54.022L160.667,78.9v31.662C148.344,102.022,133.406,97,117.311,97C75.233,97,41,131.233,41,173.311 c0,38.889,61.374,120.148,68.372,129.286c1.892,2.471,4.827,3.92,7.939,3.92s6.047-1.449,7.939-3.92 c3.399-4.438,19.625-25.89,35.417-51.237V447.979z M117.31,279.755C96.454,251,61,197.147,61,173.311 C61,142.261,86.261,117,117.311,117c31.05,0,56.311,25.261,56.311,56.311C173.622,197.127,138.166,250.992,117.31,279.755z  M321.333,423.1l-140.667,24.878V219c0.001-0.906-0.131-1.78-0.357-2.615c7.85-16.102,13.313-31.474,13.313-43.074 c0-15.716-4.779-30.336-12.956-42.489V78.9l140.667-24.878V423.1z M482,447.978L341.333,423.1V54.022L482,78.9V447.978z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M117.311,138.493c-19.199,0-34.818,15.619-34.818,34.818c0,19.199,15.619,34.818,34.818,34.818 c19.199,0,34.818-15.62,34.818-34.818S136.51,138.493,117.311,138.493z M117.311,188.129c-8.17,0-14.818-6.647-14.818-14.818 c0-8.17,6.647-14.818,14.818-14.818c8.171,0,14.818,6.647,14.818,14.818C132.129,181.482,125.482,188.129,117.311,188.129z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M458,298c5.522,0,10-4.477,10-10V102c0-5.523-4.478-10-10-10c-5.522,0-10,4.477-10,10v186 C448,293.523,452.478,298,458,298z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M458,368c5.522,0,10-4.477,10-10v-28c0-5.523-4.478-10-10-10c-5.522,0-10,4.477-10,10v28 C448,363.523,452.478,368,458,368z"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgTechnique = function SvgTechnique(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 502 502",
    style: {
      enableBackground: "new 0 0 502 502"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTechnique, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/technique.03c1df5b.svg";
export { ForwardRef as ReactComponent };